import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Logbog } from '../../models/Logbog';
import { Loading } from '../../uiComponents/Loading';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { DropdownButtonItem } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { OverflowDropdownButton, LinkPrimaryButton } from '../../uiComponents/input/Buttons';

export interface LogbogListProps {
}

interface LogbogListState {
    logboeger?: Logbog[];
}

class LogBogList extends React.Component<LogbogListProps, LogbogListState> {

    constructor(props: LogbogListProps) {
        super(props);
        this.state = {};
        this.menuFormatter = this.menuFormatter.bind(this);
    }

    componentDidMount() {
        let apiCaller = createApiCaller();

        apiCaller.getLogboeger().then(response => {
            this.setState({ logboeger: response });
        });
    }

    getLogboeger(): Logbog[] {
        if (this.state.logboeger === undefined) {
            return [];
        }
        return this.state.logboeger;
    }

    menuFormatter(cell: any, row: any) {
        return (
            <OverflowDropdownButton>
                <DropdownButtonItem href={'/logbog/rediger/' + row.id} text='Redigér' />
            </OverflowDropdownButton>
        );
    }

    getHeaderButtons() {
        return <LinkPrimaryButton url={'/logbog/ny'} text={'Ny logbog'} />;
    }

    render() {
        return (
            <PageWrapper>
                <PageTitle title='Logbøger' />
                <ContentWrapper>
                    <Loading isLoading={this.state.logboeger === undefined}>
                        <SectionGroup header={'Logbøger'} buttons={this.getHeaderButtons()}>
                            <Section fullWidth={true}>
                                <Table data={this.getLogboeger()} pagination={true} emptyText='Ingen logbøger'>
                                    <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                                    <TableHeaderColumn dataField='titel' className='first' columnClassName='first' dataSort={true}>Titel</TableHeaderColumn>
                                    <TableHeaderColumn dataField='createdDate' dataFormat={TableFormatters.dateFormatter} dataSort={true}>Oprettet</TableHeaderColumn>         
                                    <TableHeaderColumn dataField='lastChangedDate' dataFormat={TableFormatters.dateDaysFormatter} dataSort={true}>Sidst opdateret</TableHeaderColumn>         
                                    <TableHeaderColumn width='60' dataFormat={this.menuFormatter} className='table-menu' columnClassName='table-menu' />
                                </Table>
                            </Section>
                        </SectionGroup>
                    </Loading>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default LogBogList;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Logbog/LogbogList.tsx